import { put, call } from "redux-saga/effects";
import { logoutRequest } from "../../modules/auth/login";
import { getLoginUser } from "../../modules/utils/auth";

export const FORCE_LOGOUT_STATUSES = [1000, 8024, 8025];

/**
 * 정지/영구정지/인증 오류 응답 시 강제 로그아웃 처리
 * @returns {boolean} 강제 로그아웃 처리 여부
 */
export function* handleForceLogout(response) {
  if (response.data.status !== 0 && FORCE_LOGOUT_STATUSES.includes(response.data.status)) {
    yield call(alert, response.data.message);
    yield put(logoutRequest(getLoginUser()));
    // 세션/쿠키 직접 정리 후 이동 (logout saga 완료 전에 이동하면 로그인 상태 유지됨)
    sessionStorage.setItem("sessionUser", null);
    const date = new Date();
    date.setDate(date.getDate() - 1);
    document.cookie = "tid=; expires=" + date.toUTCString() + "; domain=" + process.env.REACT_APP_DOMAIN + ";path=/;SameSite=None;Secure";
    window.location.assign("/");
    return true;
  }

  return false;
}
